module.exports = __webpack_public_path__ + "img/vip-free.1c549787.png";